import { all, call, getContext, put, select } from 'redux-saga/effects';
import { ILogger } from '@cian/logger';
import { IHttpApi } from '@cian/http-api/shared';
import { IAppState } from '../../../redux/types';
import { getRosreestrData, TRosreestrDataResponse } from '../../../services/rosreestrData/getRosreestrData';
import { getParameters } from './utils/getParameters';
import { trackCheckResultReceived } from './tracking';
import { selectCadastralNumbers } from '../../../selectors/offer/selectCadastralNumbers';
import { selectCadastralFieldsMeta } from '../../../selectors/rosreestrData';
import {
  checkCadastralFieldsStart,
  updateCadastralFieldsMeta,
  setRosreestrData,
  setCadastralFieldRequired,
  setUnknownError,
} from '../../../actions/rosreestrData';
import { ECadastralFieldsNames } from '../../../types/reducers/rosreestrData';
import { IConfig } from '@cian/config/shared';

export function* checkCadastralFields() {
  const logger: ILogger = yield getContext('logger');
  const httpApi: IHttpApi = yield getContext('httpApi');
  const config: IConfig = yield getContext('config');

  const state: IAppState = yield select();
  const cadastralFields = selectCadastralNumbers(state);
  const cadastralFieldsMeta = selectCadastralFieldsMeta(state);

  const parameters = getParameters(cadastralFields, cadastralFieldsMeta);

  const checkingFields = Object.keys(parameters) as ECadastralFieldsNames[];

  yield put(checkCadastralFieldsStart(checkingFields));

  try {
    const response: TRosreestrDataResponse = yield call(getRosreestrData, {
      httpApi,
      parameters,
      logger,
      config,
    });

    if (response.success) {
      const { meta, ...rosreestrData } = response.payload;

      yield all([put(updateCadastralFieldsMeta(meta)), put(setRosreestrData(rosreestrData))]);

      trackCheckResultReceived(meta);
    }
  } catch (e) {
    yield all([
      put(setUnknownError()),
      put(setCadastralFieldRequired({ key: ECadastralFieldsNames.CadastralNumber, value: false })),
    ]);
  }
}
